module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#star",
      toString: function () {
        return this.url;
      }
    }